import controller from './login.controller';
import template from './login.html';
import './login.less';

const loginComponent = {
    template,
    controller,
    controllerAs: 'vm'
};

export default loginComponent;



// WEBPACK FOOTER //
// ./client/app/routes/onTheBeach/login/login.component.js